import useStoreState from '../../stores/useStoreState';
import CurrentTripStore from '../../stores/CurrentTripStore';
import PassengerAssistStore from '../../stores/PassengerAssistStore';
import { TripTypes } from '../../constants/AppConstants';

export const usePassengerAssistBookingModal = ({ currentJourneyData }) => {
    const currentTrip = useStoreState(CurrentTripStore);
    const { pendingTravelAssistRequests } = useStoreState(PassengerAssistStore);

    const journeys = [];

    if (currentJourneyData) { // if List view
        const { service, trip, isReturnJourney } = currentJourneyData;
        if (isReturnJourney) {
            journeys.push({
                trip,
                journey: trip.getOutwardService(),
                direction: 'Outward',
            });

            journeys.push({
                trip,
                journey: service.get('journey'),
                direction: 'Return'
            });
        } else {
            journeys.push({
                trip,
                journey: service.get('journey'),
                direction: 'Outward',
            });
        }
    } else {
        journeys.push({
            trip: currentTrip,
            journey: currentTrip.getOutwardService(),
            direction: 'Outward',
        });

        if (currentTrip.isReturn()) {
            journeys.push({
                trip: currentTrip,
                journey: currentTrip.getInwardService(),
                direction: 'Return'
            });
        }
    }

    const validJourneys = journeys.filter(j => !j.trip.isSeason() && j.trip.getType() !== TripTypes.ROVERSRANGERS);

    return {
        journeys: validJourneys,
        pendingTravelAssistRequests,
    };
};
